module.exports = __webpack_public_path__ + "static/media/bg_bottom.eb8a500f.svg";